import { type FC } from 'react';

import { type SeriaPlusSlideMarker } from '../../settings/seriaPlusTypes';
import { SeriaPlusMarker } from '../SeriaPlusMarker';

import styles from './SeriaPlusMarkers.css';

type SeriaPlusMarkersProps = {
  markers: SeriaPlusSlideMarker[];
  onTooltipClose?: () => void;
  onTooltipOpen?: () => void;
};

export const SeriaPlusMarkers: FC<SeriaPlusMarkersProps> = props => {
  const { markers, onTooltipClose, onTooltipOpen } = props;

  if (markers.length === 0) {
    return null;
  }

  return (
    <div className={styles['markers']} data-testid="seria-plus-carousel-markers">
      {markers.map(marker => (
        <SeriaPlusMarker
          key={marker.id}
          marker={marker}
          onTooltipClose={onTooltipClose}
          onTooltipOpen={onTooltipOpen}
        />
      ))}
    </div>
  );
};
